var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNullPriority(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23633 0C6.22487 0 5.48341 0.411557 4.76633 0.80958C4.10495 1.17668 3.48024 1.52344 2.66602 1.52344C1.89632 1.52344 1.10112 1.12201 0.761719 0.928002V0H0V13H0.761719V7.88267C1.23853 8.11291 1.9453 8.37891 2.66602 8.37891C3.67745 8.37891 4.41896 7.96735 5.13602 7.56933C5.79739 7.20223 6.42213 6.85547 7.23633 6.85547C8.24614 6.85547 9.30008 7.5465 9.31023 7.55323L9.90234 7.94798V0.938742C9.11917 0.421891 8.16329 0 7.23633 0ZM9.14062 6.58996C8.66381 6.35972 7.95704 6.09375 7.23633 6.09375C6.22487 6.09375 5.48341 6.50531 4.76633 6.90333C4.10495 7.27043 3.48024 7.61719 2.66602 7.61719C1.8962 7.61719 1.10084 7.21563 0.761719 7.02178V1.78892C1.23853 2.01916 1.9453 2.28516 2.66602 2.28516C3.67745 2.28516 4.41896 1.8736 5.13602 1.47558C5.79739 1.10848 6.42213 0.761719 7.23633 0.761719C8.00607 0.761719 8.80148 1.16325 9.14062 1.35713V6.58996Z",
    fill: "#131313",
    fillOpacity: 0.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullPriority);
export default __webpack_public_path__ + "static/media/NullPriority.0aedd78912a2d54dee6c69aba86b4ece.svg";
export { ForwardRef as ReactComponent };